import {AppAction} from '../../../appActions';
import {AnalyticsPanelDetailsActionsEnum} from './analyticsPanelDetailsActions';
import {AnalyticsPanelDetailsState} from './analyticsPanelDetailsState';

/*
 * Analytics Report panel.
 */

export function analyticsPanelDetailsReducer(
  state: AnalyticsPanelDetailsState,
  action: AppAction,
): AnalyticsPanelDetailsState {
  switch (action.type) {
    case AnalyticsPanelDetailsActionsEnum.SET_METRIC:
      return {
        ...state,
        selectedMetric: action.payload.metric,
        options: action.payload.options,
        customLabel: action.payload.customLabel,
        error: undefined,
        conversationsPageNumber: 1,
        selectedConversation: undefined,
      };

    case AnalyticsPanelDetailsActionsEnum.FETCH_METRICS_DETAILS:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };

    case AnalyticsPanelDetailsActionsEnum.FETCH_METRICS_DETAILS_COMPLETED: {
      return {
        ...state,
        conversations: action.payload,
        isLoading: false,
        error: undefined,
      };
    }

    case AnalyticsPanelDetailsActionsEnum.FETCH_METRICS_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case AnalyticsPanelDetailsActionsEnum.SET_CONVERSATIONS_PAGE_NUMBER:
      return {
        ...state,
        conversationsPageNumber: action.payload,
      };

    case AnalyticsPanelDetailsActionsEnum.SET_IS_SIDE_PANEL_OPEN:
      return {
        ...state,
        isSidePanelOpen: action.payload,
      };

    case AnalyticsPanelDetailsActionsEnum.SET_IS_CONVERSATION_DETAILS_SIDE_PANEL_OPEN:
      return {
        ...state,
        isConversationDetailsSidePanelOpen: action.payload,
      };

    case AnalyticsPanelDetailsActionsEnum.SET_SELECTED_CONVERSATION:
      return {
        ...state,
        selectedConversation: action.payload,
      };

    default:
      return state;
  }
}

export function makeAnalyticsPanelDetailsState(): AnalyticsPanelDetailsState {
  return {
    selectedMetric: undefined,
    options: undefined,
    customLabel: undefined,
    conversations: {
      items: [],
      nonAccessibleConversationIds: [],
      metadata: {
        totalConversations: 0,
        totalSegments: 0,
        isFinal: true,
      },
    },
    isSidePanelOpen: false,
    isConversationDetailsSidePanelOpen: false,
    selectedConversation: undefined,
    isLoading: true,
    error: undefined,
    conversationsPageNumber: 1,
  };
}
